import { Link } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import FitShapeLogo from "../../fitshapelogo.png";

const NAVBAR_ROUTES = [
  {
    route: ROUTES.DASHBOARD,
    title: "Dashboard",
  },
  {
    route: ROUTES.WORKOUTS,
    title: "Workout",
  },
  {
    route: ROUTES.EXERCISES,
    title: "Esercizi",
  },
  {
    route: ROUTES.PROGRESSIONS,
    title: "Progressioni",
  },
];
type Props = {
  isLoggedIn: boolean;
  logout: () => void;
  isDark: boolean;
  toggleDark: () => void;
};

const SunIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
      clipRule="evenodd"
    />
  </svg>
);

const MoonIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
  </svg>
);

export const NavBar: React.FC<Props> = ({ isLoggedIn, logout, isDark, toggleDark }) => {
  return (
    <nav className="sticky top-0 z-50 flex justify-start px-4 py-3">
      <div className="flex items-center gap-4 px-5 py-2.5 rounded-full bg-white/55 dark:bg-gray-800/70 backdrop-blur-lg border border-white/60 dark:border-gray-700/60 shadow-[0_8px_32px_0_rgba(0,0,0,0.12)]">
        <img src={FitShapeLogo} className="h-10 w-auto" alt="Fitshape Logo" />

        {isLoggedIn && (
          <>
            <ul className="flex items-center gap-1">
              {NAVBAR_ROUTES.map(({ route, title }) => (
                <li key={title}>
                  <Link
                    to={route}
                    className="px-4 py-2 text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white rounded-full hover:bg-gray-900/6 dark:hover:bg-white/10 transition-colors"
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>

            <button
              type="button"
              onClick={toggleDark}
              className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white rounded-full hover:bg-gray-900/6 dark:hover:bg-white/10 transition-colors"
              title={isDark ? "Passa a modalit\u00e0 chiara" : "Passa a modalit\u00e0 scura"}
            >
              {isDark ? <SunIcon /> : <MoonIcon />}
            </button>

            <button
              type="button"
              onClick={logout}
              className="px-5 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 border border-gray-400/50 dark:border-gray-600/50 rounded-full hover:bg-gray-100/80 dark:hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              Logout
            </button>
          </>
        )}
      </div>
    </nav>
  );
};
